<template>
    <div class="row workorder">
        <div class="col-md-2 first-col d-none d-md-inline-block">
            <div class="block">
                <h3>{{$t('FILTERNOTIFICATIONS')}}</h3>
                <form method="get" action="">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{$t('STARTDATE')}}</label>
                            <datepicker v-model="pagination.startDate" input-class="secondary" :bootstrapStyling="true" format="dd.MM.yyyy" v-bind:placeholder="$t('STARTDATE')"></datepicker>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{$t('ENDDATE')}}</label>
                            <datepicker v-model="pagination.endDate" input-class="secondary" :bootstrapStyling="true" format="dd.MM.yyyy" v-bind:placeholder="$t('ENDDATE')"></datepicker>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-md-10 col-12 last-col enable-scroll">
            <div class="row header-info notif">
                <div class="col-md-12">{{$t('NOTIFICATIONSFROM')}} <b>{{formatDate(pagination.startDate)}}</b> {{$t('NOTIFICATIONSTO')}} <b>{{formatDate(pagination.endDate)}}</b></div>
            </div>
            <div class="notifications" v-for="(notification, day) in notifications.root">
                <div class="date">{{formatDateDay(day)}}</div>
                <ul class="list-unstyled">
                    <li v-for="notif in notification">
                        <div class="row">
                            <div class="col-2">
                                <img v-if="notif.type == 'task'" src="../assets/img/icon-tasks-grey.svg" />
                                <img v-if="notif.type == 'chat'" src="../assets/img/icon-chat-grey.svg" />
                                <img v-if="notif.type == 'workorder' || notif.type == 'dentalsolution'" src="../assets/img/icon-nalog-grey.svg" />
                            </div>
                            <div class="col-8">{{notif.notice}}</div>
                            <div class="col-2">
                                <router-link v-if="notif.workOrderId" :to="{ path: '/workorders/'+notif.workOrderId, query: { open: (notif.type == 'task' ? 'tasks' : (notif.type == 'task' ? 'chat' : 'workorder')) }}"><img src="../assets/img/icon-nalog-blue.svg" /></router-link>
                                <router-link v-if="notif.dentalSolutionId" :to="{ path: '/dentalsolutions/'+notif.dentalSolutionId, query: { open: (notif.type == 'task' ? 'tasks' : (notif.type == 'task' ? 'chat' : 'dentalsolution')) }}"><img src="../assets/img/icon-nalog-blue.svg" /></router-link>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <b-pagination align="center" v-if="notifications.totalCount > 20" :total-rows="notifications.totalCount" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
        </div>
    </div>
</template>

<script>
import notificationsApi from '@/api/notifications'
import moment from 'moment'

export default
{
    name: 'Notifications',
    data: function()
    {
        return {
            notifications:
            {},
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 20,
                startDate: moment().subtract(31, 'days').format(),
                endDate: new Date()
            }
        };
    },
    created: function()
    {
        var me = this;
        me.getNotifications();
    },
    methods:
    {
        getNotifications: function()
        {
            var me = this;
            me.tasks = {};
            notificationsApi.getNotifications(me.getParams, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.notifications = data;
            });
        },
        formatDateDay: function(day)
        {
            return moment(day).format('DD.MM.YYYY.');
        }
    },
    watch:
    {
        'pagination.startDate': function(newValue, oldValue)
        {
            var me = this;
            me.getNotifications();
        },
        'pagination.endDate': function(newValue, oldValue)
        {
            var me = this;
            me.getNotifications();
        },
        'pagination.currentPage': function(newValue, oldValue)
        {
            var me = this;
            me.getNotifications();
        }
    },
    computed:
    {
        getParams: function()
        {
            var me = this;
            var data = Object.assign(
            {}, me.pagination,
            {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Notifications.vue